/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React, { useState } from "react";

import Row from 'components/Grid/Row';
import Col from 'components/Grid/Col';
import Icon from "components/Icon";

import * as Styled from './styles';

const TagsList3 = ({ hideTrash, disableType, tags, disabled, removeTag, small, showRecipients = false }) => {
    /*
        function base64ToArrayBuffer(base64) {
            var binaryString = window.atob(base64);
            var binaryLen = binaryString.length;
            var bytes = new Uint8Array(binaryLen);
            for (var i = 0; i < binaryLen; i++) {
                var ascii = binaryString.charCodeAt(i);
                bytes[i] = ascii;
            }
            return bytes;
        }
    
        function saveByteArray(reportName, byte, t) {
            var blob = new Blob([byte], { type: t });
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            var fileName = reportName;
            link.download = fileName;
            link.click();
        };
    
          useEffect(()=>{
             console.log('files',props.tags);
         },[props.tags]) */

    const [hoveredContact, setHoveredContact] = useState(null);

    function showToolTip(email, idDocument, tagIndex) {
        return (
            hoveredContact?.email === email &&
            hoveredContact?.idDocument === idDocument &&
            hoveredContact?.tagIndex === tagIndex
        )
    };

    return (
        <Styled.Container>
            {tags && tags.map((tag, index) => (
                <Styled.Tags key={index}>
                    {(tag.dsTypeDocument) && (
                        <Col md={3} sm={3} xs={3}>
                            <Styled.DocumentType>
                                {tag.dsTypeDocument}
                            </Styled.DocumentType>
                        </Col>
                    )}

                    <Col md={4} sm={4} xs={4}>
                        <Styled.Tag onClick={() => window.open(tag.urlLink, "_blank")}>
                            <Styled.TagTitle >{tag.nameDocument || tag.fileName}</Styled.TagTitle>
                        </Styled.Tag>
                    </Col >

                    <Col md={1} sm={1} xs={1} style={{ padding: "0px 0px 0px 0px", direction: "rtl" }}>
                        {hideTrash == false ?
                            <Row>
                                {console.log(hideTrash)}
                                <Icon name="trash" style={{ cursor: 'pointer' }} onClick={() => removeTag(index)}></Icon>
                            </Row>
                            : ''}
                    </Col>
                    {showRecipients && (
                        <Col md={4} sm={4} xs={4} style={{ display: 'flex', flexWrap: 'wrap', gap: '12px' }}>
                            {tag.recipients?.map((recipient, tagIndex) => (
                                <Row
                                    key={tagIndex}
                                    onMouseEnter={() =>
                                        setHoveredContact({ ...recipient, idDocument: tag.idDocument, tagIndex })
                                    }
                                    onMouseLeave={() => setHoveredContact(null)}
                                >
                                    <Styled.Tooltip show={showToolTip(recipient.email, tag.idDocument, tagIndex)}>
                                        {recipient.email}
                                    </Styled.Tooltip>
                                    <Styled.TagRecipient>{recipient.nameContact}</Styled.TagRecipient>
                                </Row>
                            ))}
                        </Col>

                    )}
                    <Styled.Line />
                </Styled.Tags >
            ))}

        </Styled.Container >
    );
};
export default TagsList3;